import _ from 'lodash';
import config from 'client/shared/config';
import { toast } from 'react-toastify';

import {
	observable,
	action,
	computed,
	runInAction
} from 'mobx';

import BaseStore from './base-store';
import Document from './document';

const { routes } = config;

class DocumentStore extends BaseStore {
	apiRoute = routes.documents;

	/**
	 * Observables & Computeds
	 */

	 // TODO: Issue relateed to this?...
	@computed
	get data () {
		return {
			document: this._data.item
		};
	}

	@computed
	get documents () {
		return this._items;
	}

	set documents (documents) {
		this._items = documents;
	}

	@computed
	get orderedDocuments () {
		return _(this.documents).sortBy('orderIndex').value();
	}

	@computed
	get documentsByTitle () {
		return _(this.documents).sortBy('label').value();
	}

	@computed
	get documentsByUpdated () {
		return _(this.documents).sortBy('updatedAt').value();
	}

	@computed
	get documentsByCreated () {
		return _(this.documents).sortBy('createdAt').value();
	}

	// @computed
	// get documentsByType () {
	// 	return _(
	// 		// _.map(this.documents, function(doc) {
	// 		_.map(this.testDocuments, function(doc) {

	// 			if (doc.type == type) return doc;
	// 		})
	// 	).sortBy('orderIndex').value();
	// }

	@computed
	get testDocuments () {
		return [
			{'_id': '1',
				'type': 'FAN_FAQ',
				'title': 'How do you create an account',
				'content': 'SHORT Lorem ipsum dolor.',
				'orderIndex': 1
			},
			{'_id': '2',
				'type': 'FAN_FAQ',
				'title': 'How do I download a song?',
				'content': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse commodo bibendum dignissim. Nulla facilisi. Aenean lacus tellus, tincidunt id lorem vitae, mollis scelerisque tellus. Nam id dapibus nibh, sed cursus purus. Duis gravida elit augue, nec blandit ante tempus et. Cras vehicula hendrerit mi, sit amet luctus libero aliquet sed. Nullam pretium lacus iaculis massa dapibus pellentesque. Vivamus elementum orci a augue maximus placerat.\n\nNunc commodo ante ut elit scelerisque finibus. Integer feugiat erat felis, vitae dignissim dui interdum vitae. Donec et congue tortor. Nam ultrices, tortor eu venenatis cursus, diam elit luctus lacus, et fermentum risus neque vel nulla. Etiam scelerisque bibendum pellentesque. In hac habitasse platea dictumst. Nullam ornare lacus vitae leo consectetur sagittis. Ut sed erat augue. Vivamus vitae laoreet mi. Fusce ex arcu, consequat vitae magna nec, gravida luctus lorem. Sed iaculis ante vitae elit scelerisque consequat. Curabitur pellentesque, massa in facilisis maximus, massa leo fringilla justo, eu bibendum leo odio vel nisl. Vivamus sed purus at tellus laoreet ullamcorper. Curabitur tristique congue pulvinar. Nunc euismod gravida dolor sit amet euismod.\n\nSed ac nisi ac purus euismod pulvinar. Nunc placerat, neque at tincidunt suscipit, eros urna sagittis dolor, quis sodales justo mi et leo. Nulla ac augue a ligula pharetra convallis ut sed leo. Vivamus in sem dui. Duis eu quam commodo nunc tempor consectetur quis vel mauris. Sed sed pellentesque mauris. Donec iaculis faucibus erat in ornare. Praesent nunc arcu, vestibulum sit amet imperdiet at, porttitor nec quam. Pellentesque at consectetur risus, ac tincidunt velit. Proin vel nunc vitae lectus consectetur ultrices sit amet quis neque. Praesent in aliquet metus.\n\nSed rutrum lorem nec auctor posuere. Fusce dapibus sagittis nulla, vel congue elit imperdiet ut. Cras lacus mi, iaculis a accumsan in, porttitor a velit. In sed metus non ipsum gravida viverra sed at augue. Morbi massa enim, tincidunt ac orci a, pellentesque suscipit velit. Nunc vel semper nulla. Donec rutrum dui id luctus egestas. Etiam dignissim magna id neque blandit, sed tincidunt est rutrum. Nam sed quam elit. Phasellus mattis at velit dignissim hendrerit. Vivamus tristique pulvinar est ut maximus. Donec malesuada placerat ante, non rutrum arcu tristique ullamcorper.',
				'orderIndex': 0
			},
			{'_id': '3',
				'type': 'ARTIST_FAQ',
				'title': 'How do I upload Music?',
				'content': 'SHORT Lorem ipsum dolor.',
				'orderIndex': 0
			},
			{'_id': '4',
				'type': 'ARTIST_FAQ',
				'title': 'What is Stripe?',
				'content': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse commodo bibendum dignissim. Nulla facilisi. Aenean lacus tellus, tincidunt id lorem vitae, mollis scelerisque tellus. Nam id dapibus nibh, sed cursus purus. Duis gravida elit augue, nec blandit ante tempus et. Cras vehicula hendrerit mi, sit amet luctus libero aliquet sed. Nullam pretium lacus iaculis massa dapibus pellentesque. Vivamus elementum orci a augue maximus placerat.\n\nNunc commodo ante ut elit scelerisque finibus. Integer feugiat erat felis, vitae dignissim dui interdum vitae. Donec et congue tortor. Nam ultrices, tortor eu venenatis cursus, diam elit luctus lacus, et fermentum risus neque vel nulla. Etiam scelerisque bibendum pellentesque. In hac habitasse platea dictumst. Nullam ornare lacus vitae leo consectetur sagittis. Ut sed erat augue. Vivamus vitae laoreet mi. Fusce ex arcu, consequat vitae magna nec, gravida luctus lorem. Sed iaculis ante vitae elit scelerisque consequat. Curabitur pellentesque, massa in facilisis maximus, massa leo fringilla justo, eu bibendum leo odio vel nisl. Vivamus sed purus at tellus laoreet ullamcorper. Curabitur tristique congue pulvinar. Nunc euismod gravida dolor sit amet euismod.\n\nSed ac nisi ac purus euismod pulvinar. Nunc placerat, neque at tincidunt suscipit, eros urna sagittis dolor, quis sodales justo mi et leo. Nulla ac augue a ligula pharetra convallis ut sed leo. Vivamus in sem dui. Duis eu quam commodo nunc tempor consectetur quis vel mauris. Sed sed pellentesque mauris. Donec iaculis faucibus erat in ornare. Praesent nunc arcu, vestibulum sit amet imperdiet at, porttitor nec quam. Pellentesque at consectetur risus, ac tincidunt velit. Proin vel nunc vitae lectus consectetur ultrices sit amet quis neque. Praesent in aliquet metus.\n\nSed rutrum lorem nec auctor posuere. Fusce dapibus sagittis nulla, vel congue elit imperdiet ut. Cras lacus mi, iaculis a accumsan in, porttitor a velit. In sed metus non ipsum gravida viverra sed at augue. Morbi massa enim, tincidunt ac orci a, pellentesque suscipit velit. Nunc vel semper nulla. Donec rutrum dui id luctus egestas. Etiam dignissim magna id neque blandit, sed tincidunt est rutrum. Nam sed quam elit. Phasellus mattis at velit dignissim hendrerit. Vivamus tristique pulvinar est ut maximus. Donec malesuada placerat ante, non rutrum arcu tristique ullamcorper.',
				'orderIndex': 1
			},
			{'_id': '5',
				'type': 'TOS',
				'label': 'Muzado Terms of Service',
				'content': 'Muzado Terms of Service SHORT Lorem ipsum dolor.',
				'orderIndex': -1
			},
			{'_id': '6',
				'type': 'PRIVACY',
				'title': 'Muzado Privacy Policy',
				'content': 'Muzado Privacy Policy Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse commodo bibendum dignissim. Nulla facilisi. Aenean lacus tellus, tincidunt id lorem vitae, mollis scelerisque tellus. Nam id dapibus nibh, sed cursus purus. Duis gravida elit augue, nec blandit ante tempus et. Cras vehicula hendrerit mi, sit amet luctus libero aliquet sed. Nullam pretium lacus iaculis massa dapibus pellentesque. Vivamus elementum orci a augue maximus placerat.\n\nNunc commodo ante ut elit scelerisque finibus. Integer feugiat erat felis, vitae dignissim dui interdum vitae. Donec et congue tortor. Nam ultrices, tortor eu venenatis cursus, diam elit luctus lacus, et fermentum risus neque vel nulla. Etiam scelerisque bibendum pellentesque. In hac habitasse platea dictumst. Nullam ornare lacus vitae leo consectetur sagittis. Ut sed erat augue. Vivamus vitae laoreet mi. Fusce ex arcu, consequat vitae magna nec, gravida luctus lorem. Sed iaculis ante vitae elit scelerisque consequat. Curabitur pellentesque, massa in facilisis maximus, massa leo fringilla justo, eu bibendum leo odio vel nisl. Vivamus sed purus at tellus laoreet ullamcorper. Curabitur tristique congue pulvinar. Nunc euismod gravida dolor sit amet euismod.\n\nSed ac nisi ac purus euismod pulvinar. Nunc placerat, neque at tincidunt suscipit, eros urna sagittis dolor, quis sodales justo mi et leo. Nulla ac augue a ligula pharetra convallis ut sed leo. Vivamus in sem dui. Duis eu quam commodo nunc tempor consectetur quis vel mauris. Sed sed pellentesque mauris. Donec iaculis faucibus erat in ornare. Praesent nunc arcu, vestibulum sit amet imperdiet at, porttitor nec quam. Pellentesque at consectetur risus, ac tincidunt velit. Proin vel nunc vitae lectus consectetur ultrices sit amet quis neque. Praesent in aliquet metus.\n\nSed rutrum lorem nec auctor posuere. Fusce dapibus sagittis nulla, vel congue elit imperdiet ut. Cras lacus mi, iaculis a accumsan in, porttitor a velit. In sed metus non ipsum gravida viverra sed at augue. Morbi massa enim, tincidunt ac orci a, pellentesque suscipit velit. Nunc vel semper nulla. Donec rutrum dui id luctus egestas. Etiam dignissim magna id neque blandit, sed tincidunt est rutrum. Nam sed quam elit. Phasellus mattis at velit dignissim hendrerit. Vivamus tristique pulvinar est ut maximus. Donec malesuada placerat ante, non rutrum arcu tristique ullamcorper.',
				'orderIndex': -1
			},
			{'_id': '7',
				'type': 'ABOUT',
				'title': 'About Muzado',
				'content': 'About Muzado SHORT Lorem ipsum dolor.',
				'orderIndex': -1
			},
			{'_id': '8',
				'type': 'PRESS',
				'title': 'Muzado Press Info',
				'content': 'Muzado Press Info Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse commodo bibendum dignissim. Nulla facilisi. Aenean lacus tellus, tincidunt id lorem vitae, mollis scelerisque tellus. Nam id dapibus nibh, sed cursus purus. Duis gravida elit augue, nec blandit ante tempus et. Cras vehicula hendrerit mi, sit amet luctus libero aliquet sed. Nullam pretium lacus iaculis massa dapibus pellentesque. Vivamus elementum orci a augue maximus placerat.\n\nNunc commodo ante ut elit scelerisque finibus. Integer feugiat erat felis, vitae dignissim dui interdum vitae. Donec et congue tortor. Nam ultrices, tortor eu venenatis cursus, diam elit luctus lacus, et fermentum risus neque vel nulla. Etiam scelerisque bibendum pellentesque. In hac habitasse platea dictumst. Nullam ornare lacus vitae leo consectetur sagittis. Ut sed erat augue. Vivamus vitae laoreet mi. Fusce ex arcu, consequat vitae magna nec, gravida luctus lorem. Sed iaculis ante vitae elit scelerisque consequat. Curabitur pellentesque, massa in facilisis maximus, massa leo fringilla justo, eu bibendum leo odio vel nisl. Vivamus sed purus at tellus laoreet ullamcorper. Curabitur tristique congue pulvinar. Nunc euismod gravida dolor sit amet euismod.\n\nSed ac nisi ac purus euismod pulvinar. Nunc placerat, neque at tincidunt suscipit, eros urna sagittis dolor, quis sodales justo mi et leo. Nulla ac augue a ligula pharetra convallis ut sed leo. Vivamus in sem dui. Duis eu quam commodo nunc tempor consectetur quis vel mauris. Sed sed pellentesque mauris. Donec iaculis faucibus erat in ornare. Praesent nunc arcu, vestibulum sit amet imperdiet at, porttitor nec quam. Pellentesque at consectetur risus, ac tincidunt velit. Proin vel nunc vitae lectus consectetur ultrices sit amet quis neque. Praesent in aliquet metus.\n\nSed rutrum lorem nec auctor posuere. Fusce dapibus sagittis nulla, vel congue elit imperdiet ut. Cras lacus mi, iaculis a accumsan in, porttitor a velit. In sed metus non ipsum gravida viverra sed at augue. Morbi massa enim, tincidunt ac orci a, pellentesque suscipit velit. Nunc vel semper nulla. Donec rutrum dui id luctus egestas. Etiam dignissim magna id neque blandit, sed tincidunt est rutrum. Nam sed quam elit. Phasellus mattis at velit dignissim hendrerit. Vivamus tristique pulvinar est ut maximus. Donec malesuada placerat ante, non rutrum arcu tristique ullamcorper.',
				'orderIndex': -1
			}
		];
	}

	/**
	 * Action
	 */

	@action
 	newDocument (data = {}) {
 		const document = new Document(this, data);
 		this.documents.unshift(document);

 		return document;
 	}

	@action
	async saveDocument (document, opts = {}) {
		this.isLoading = opts.silent !== true;

		try {

			const route = _.isEmpty(document.id) ? routes.documentCreate : this.apiRoute;
			await this.save(document, { route });
			toast.success('Document saved!');
		} catch (err) {

			toast.error('Error saving document!');
			throw err;
		} finally {

			this.isLoading = false;
		}
	}

	@action
	deleteDocument (document) {
		this.delete(document);
		toast.success('Document deleted!');
	}
}

const documentStore = new DocumentStore();
export default documentStore;
